// utils/fileUtils.js
export const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const validateFiles = (files, showToast) => {
  return files.filter((file) => {
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      showToast(`File type not allowed: ${file.name}`, "error");
      return false;
    }
    if (file.size > MAX_FILE_SIZE) {
      showToast(`File too large (max 10MB): ${file.name}`, "error");
      return false;
    }
    return true;
  });
};

export const formatFileSize = (bytes) => {
  if (!bytes || isNaN(bytes)) return "0 KB";
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(2)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(2)} MB`;
};

export const getFileIcon = (fileName) => {
  const iconMap = {
    image: "bi-image-fill text-btn-primary",
    pdf: "bi-file-earmark-pdf-fill text-danger",
    doc: "bi-file-earmark-word-fill text-btn-primary",
    default: "bi-file-earmark-fill",
  };

  if (fileName.match(/\.(jpg|jpeg|png|gif|webp)$/i)) return iconMap.image;
  if (fileName.match(/\.pdf$/i)) return iconMap.pdf;
  if (fileName.match(/\.(doc|docx)$/i)) return iconMap.doc;
  return iconMap.default;
};

export const fetchFileSize = async (url) => {
  try {
    const response = await fetch(url, { method: "HEAD" });
    const size = response.headers.get("Content-Length");
    return size ? parseInt(size, 10) : null;
  } catch (error) {
    console.error("Error fetching size for", url, error);
    return null;
  }
};
